
import localization from '~/mixins/localization'

export default {
  mixins: [localization],

  props: {
    value: {
      type: String,
      default: null,
    },

    config: {
      type: Object,
      required: true,
    },

    options: {
      type: Object,
      required: true,
    },

    rules: {
      type: [String, Object],
      default: '',
    },

    name: {
      type: String,
      required: null,
      default: null,
    },

    label: {
      type: String,
      default: '',
    },

    instructions: {
      type: String,
      default: null,
    },

    validationMode: {
      type: String,
      default: 'lazy',
    },

    event: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      innerValue: this.value,
    }
  },

  computed: {
    computedOptions() {
      return Object.entries(this.options)
    },
  },

  watch: {
    innerValue(innerValue) {
      this.$emit('input', innerValue)
    },

    value(value) {
      this.innerValue = value
    },
  },

  methods: {
    fullyBooked(id) {
      let isFullyBooked = false

      if (!this.event || !id) return isFullyBooked

      // Get the first id since the id is a combination of all localized ids
      id = this.getLocalizedId(id)

      const foundTopic = this.findTopicInEventById(id)

      if (foundTopic) {
        // Check if topic is fully booked
        if (
          parseInt(foundTopic.amount_of_signups) >=
          parseInt(foundTopic.max_participants)
        ) {
          isFullyBooked = true
        }
      }

      return isFullyBooked
    },

    getSubtitleOfEventTopic(ids) {
      const id = this.getLocalizedId(ids)

      if (!this.event || this.hasDaysWithContingent()) return false

      const foundTopic = this.findTopicInEventById(id)

      if (!foundTopic || !foundTopic?.subtitle) return null

      return this.localizedLabel(foundTopic?.subtitle)
    },

    findTopicInEventById(id) {
      if (this.hasDaysWithContingent()) {
        return this.event.days.find((day) => day.id === id)
      }

      for (const day of this.event.days) {
        for (const slot of day.time_slots) {
          for (const topic of slot.topics) {
            if (topic.id === id) {
              return topic
            }
          }
        }
      }
      return null
    },

    hasDaysWithContingent() {
      return this.event.days.some(
        (day) => day.blueprint === 'day_with_contingent'
      )
    },

    getLocalizedId(ids) {
      const splitted = ids.split('_')
      const locales = this.$i18n.locales

      // create an object where first index is DE, second is FR, third is IT based on the locale
      const localeIDs = locales.reduce((acc, locale, index) => {
        acc[locale.code] = splitted[index]
        return acc
      }, {})

      return localeIDs[this.$i18n.locale]
    },

    getValue(value) {
      const splitted = value.split('_')

      if (splitted.length > 0) {
        return splitted[0]
      }

      return value
    },
  },
}
